var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCzech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.847,
    height: 37.848,
    viewBox: "0 0 37.847 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffd446;}.b{fill:#f0f0f0;}.c{fill:#fa0b54;}.d{fill:#0b34ef;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37.847,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.715 5.896)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -8.71, -5.9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.287 0.102)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-0.001 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.134,256s-6.148,7.018-6.154,7.017A9.923,9.923,0,0,0,91.92,256Z",
    transform: "translate(-72.074 -246.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2.906,74.98a9.923,9.923,0,0,0,0,14.034L9.923,82Z",
    transform: "translate(0 -72.072)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzech);
export default __webpack_public_path__ + "static/media/czech.0cd4a84d9db9f12b3258ade81990d987.svg";
export { ForwardRef as ReactComponent };